import { createResponse } from "../lib/functions";
import golApiCall from "./golApiCall";

export function getGolRequestVoidReservationQuery(reservationId: string) {
  return {
    GolApi: {
      RequestDetail: {
        VoidReservationsRequest_1: {
          VoidReservations: {
            VoidReservation: [
              {
                Reservation: {
                  ReservationId: reservationId,
                },
              },
            ],
          },
        },
      },
    },
  };
}

export default async (reservationId: string) => {
  const golRequest = getGolRequestVoidReservationQuery(reservationId);
  const voidReservationResponse = await golApiCall(golRequest);

  return createResponse(voidReservationResponse);
};
